import React from "react";
// import TableComandas from "../components/TableComandas";
import AppRendicionReactTable from "../table/AppRendicionReactTable";

import Footer from "../components/Footer";

import "../css/footer.css";

const Rendiciones = () => {
  return (
    <>
      <AppRendicionReactTable />
      {/* <TableComandas /> */}
      <Footer />
    </>
  );
};

export default Rendiciones;
